<div class="header_search">
  <div class="content_search">
    <div class="new-project btn-wx" *ngIf="permission?.createIssue">
      <button class="btn btn-default" type="btn" *ngIf="!ordenacao" (click)="ordenacao = true">Ordenação</button>
      <button class="btn btn-default" type="btn" *ngIf="ordenacao" (click)="salvarOrdem()">Salvar Ordem</button>
    </div>
    <div class="new-project" *ngIf="permission?.createIssue">
      <a class="btn btn-primary" type="btn" routerLink="adicionar">Nova</a>
    </div>
  </div>
</div>

<div class="system-table table-container">
  <div class="d-flex justify-content-end mb-2">
    <a class="btn btn-primary" [href]="linkGantt">Editar Cronograma</a>
    <!--<a class="btn btn-primary" routerLink="../gantt">Editar Cronograma</a>-->
  </div>
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="text-center">Resumo Monitoramento</th>
          <th class="text-center">Percentual Execução</th>
          <th class="text-center">Percentual Previsto de Execução</th>
          <th class="text-center">Conclusão Cronograma</th>
          <th class="text-center">Conclusão<br>Linha de Base</th>
          <th class="text-center">Dias de atraso <br> projetados</th>
          <th class="text-center">Atualização</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="title status text-center" >
            <span class="d-grid" *ngIf="cronogramaMonitoramento?.end_baseline">
              <span class="font-icon-fill dot" [class]="cronogramaMonitoramento?.status?.icon == 'check_circle_unread'? 'font-icon-status':''" [style]="{'color': cronogramaMonitoramento?.status?.color}">{{cronogramaMonitoramento?.status?.icon}}</span>
              {{cronogramaMonitoramento?.status?.label}}
            </span>
          </td>
          <td class="text-center">{{cronogramaMonitoramento?.progress}}</td>
          <td class="text-center">{{cronogramaMonitoramento?.foreseen_executed ? (cronogramaMonitoramento?.foreseen_executed | number:'1.0-0') : 0}}</td>
          <td class="text-center">{{cronogramaMonitoramento?.end| date: 'dd/MM/yyyy':'UTC' }}</td>
          <td class="text-center">{{cronogramaMonitoramento?.end_baseline| date: 'dd/MM/yyyy':'UTC' }}</td>
          <td class="text-center">{{cronogramaMonitoramento?.days_late}}</td>
          <td class="text-center">{{cronogramaMonitoramento?.ctr_dth_atu| date: 'dd/MM/yyyy':'UTC' }}</td>
        </tr>
      </tbody>
    </table>
    <table cdkDropList (cdkDropListDropped)="drop($event)" [cdkDropListDisabled]="!ordenacao" [ngClass]="{'ordenacao': ordenacao}">
      <thead>
        <tr>
          <th colspan="5">Etapas e tarefas</th>
          <th colspan="1" class="text-center">Entregas</th>
          <th colspan="1" class="text-center">Responsável</th>
          <th colspan="1" class="text-center">Status</th>
          <th colspan="1" class="text-center">Percentual Execução</th>
          <th colspan="1" class="text-center">Conclusão Prevista</th>
          <th colspan="1" class="text-center">Conclusão Linha de Base</th>
          <th colspan="1" class="text-center" title="Ponto crítico">Ponto Crítico</th>
          <th colspan="1" class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="!entregasList?.length" class="border-b-radius">
          <td colspan="13" class="text-center">Nenhuma Entrega Cadastrada.</td>
        </tr>
        <ng-container *ngFor="let item of orderData(entregasList); let i = index">
          <ng-content *ngTemplateOutlet="tmplRef;
            context: { variable: item, index: i, level: 0,agencyParent:0} ">
          </ng-content>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>
<ng-template #tmplRef let-variable="variable" let-index="index" let-level="level" let-agencyParent="agencyParent">
      <tr  class="tr-{{index % 2}} level-{{level}}" >
        <ng-container >
          <td colspan="5">
            <div class="d-flex justify-content-start">
              <span class="font-icon pointer expand" [ngClass]="{'hidden': !(variable?.['pf_prt_issue_childs']?.length > 0 || false)}"
                (click)="variable['show_body'] = variable['show_body'] != null? !variable['show_body']:true">
                {{variable?.show_body? 'remove':'add'}}
              </span>
              <span class="pointer" (click)="variable['show_body'] = variable['show_body'] != null? !variable['show_body']:true"> 
                {{variable['description']}}
                <span class="info-text">
                  <div class="d-flex responsavel">
                    <span class="icon-person font-icon icon-fill text-dark me-2" alt="Exibir detalhes do usuário" title="Exibir detalhes do usuário"
                      *ngIf="variable?.pf_prt_issue_manager_main?.tb_pss_pessoa"
                      (click)="variable.show_resp = variable['show_resp'] != null? !variable['show_resp']:true">
                      person
                    </span>
                    <div *ngIf="variable?.level_mon_id == 1" class="tag">Estratégico</div>
                    <div *ngIf="variable?.irfe_id" class="tag irfe">IRFE</div>
                    <div *ngIf="variable?.ircp_id" class="tag ircp">IRCP</div>
                  </div>
                  <span class="info-text" *ngIf="variable.show_resp">
                    <ng-container *ngIf="variable?.pf_prt_issue_manager_main?.tb_pss_pessoa as person">
                      Resp.: {{person?.str_nome}}
                      <span *ngIf="person?.str_email_responsavel_projeto">
                        <br/>
                        E-mail.: {{person?.str_email_responsavel_projeto}}
                      </span>
                      <span *ngIf="person?.num_telefone_1">
                        <br/>
                        Telefone.: ({{person?.num_ddd_1}}) {{person?.num_telefone_1}}
                      </span>
                    </ng-container>
                  </span>
                </span>
              </span>
            </div>
          </td>
          <td colspan="1" class="text-center">
            <img *ngIf="!variable.end_is_milestone && !variable.start_is_milestone && hasMilestoneInChild(variable)" src="assets/images/svgs/marco_filho.svg" title="Contém marcos">
            <span class="font-icon-fill flag" *ngIf="variable.end_is_milestone || variable.start_is_milestone" title="É um Marco">flag_2</span>
          </td>
          <td colspan="1" class="text-center agency-td">{{agencyParent == variable?.tb_org_orgao?.num_codigo_pk ? '' : variable?.tb_org_orgao?.str_sigla || variable?.tb_org_orgao?.str_nome}}</td>
          <td colspan="1" class="text-center">
            <span *ngIf="getStatus(variable.status1) as status" class="d-grid">
              <span class="font-icon-fill dot" [style]="{'color': status.color}">circle</span>
              {{status.label}}
            </span>
          </td>
          <td colspan="1" class="text-center">{{variable?.progress}}</td>
          <td colspan="1" class="text-center">{{variable?.dt_conclusion| date: 'dd/MM/yyyy':'UTC'}}</td>
          <td colspan="1" class="text-center">{{getBaseline(variable, level == 0)?.end | date: 'dd/MM/yyyy':'UTC' }}</td>
          <td colspan="1" class="text-center text-danger">{{ variable?.pf_prt_issue_critical_active_count > 0 ? variable?.pf_prt_issue_critical_active_count ?? '': ''}}</td>
          <td colspan="1" class="div-center">
            <button class="button-icon font-icon me-1" *ngIf="(variable?.pf_prt_analysis_last?.description || variable?.pf_prt_issue_critical_active?.length > 0)"  title="Expandir Análise"
              (click)="variable['show_description'] = variable['show_description'] != null? !variable['show_description']:true">
              manage_search
            </button>
            <button class="button-icon font-icon"  *ngIf="!variable.is_project" (click)="openIssue(variable.id)"  title="Abrir etapa">
              search
            </button>
          </td>
        </ng-container>
      </tr>
      <ng-container>
        <tr *ngIf="variable.show_description == true" class="tr-{{index % 2}} child-tr level-{{level+1}}">
          <td colspan="13"  class=" child-td description-div">
            <ng-container *ngIf="variable?.pf_prt_analysis_last?.description">
              <b>Análise:</b> {{variable?.pf_prt_analysis_last?.description}}<br>
              <b>Data de atualização: {{variable?.pf_prt_analysis_last?.ctr_dth_atu | date: 'dd/MM/yyyy'}}.</b>
            </ng-container>
            <hr *ngIf="variable?.pf_prt_analysis_last?.description && variable?.pf_prt_issue_critical_active.length > 0 ">
            <ng-container *ngFor="let critial of variable?.pf_prt_issue_critical_active" >
              <ng-container *ngIf="critial.critical_stat_id != 2">
              <b>Ponto crítico:</b> {{critial?.description}}<br>
                <b>Data de atualização: {{critial?.ctr_dth_atu | date: 'dd/MM/yyyy'}}.</b>
                <br>
              </ng-container>
            </ng-container>
            <ng-container *ngIf="variable?.pf_prt_analysis_last?.pf_prt_issue_extra_value?.length > 0">
              <table>
                <thead>
                  <tr class="tr-line">
                    <th colspan="3" class="title">Titulo</th>
                    <th colspan="2" class="text-center">Unid. Med.</th>
                    <th colspan="2" class="text-center">Meta</th>
                    <th colspan="2" class="text-center">Realizado</th>
                    <th colspan="2" class="text-center">% Real</th>
                  </tr>
                </thead>
                <tbody >
                  <tr *ngFor="let extra of variable?.pf_prt_analysis_last?.pf_prt_issue_extra_value">
                    <td colspan="3" class="td-medida title">{{extra?.pf_prt_issue_extra?.title}}</td>
                    <td colspan="2" class="text-center">{{extra?.pf_prt_issue_extra?.unit_id}}</td>
                    <td colspan="2" class="text-center">{{(extra?.goal ?? extra?.pf_prt_issue_extra?.goal) | number:formatoDecimal(extra)}}</td>
                    <td colspan="2" class="text-center">{{extra?.done | number:'1.0-2'}}</td>
                    <td colspan="2" class="text-center">{{getRealValue(extra) | number:'1.2-2'}}</td>
                  </tr>
                </tbody>
              </table>

            </ng-container>
          </td>
        </tr>
        <tr *ngIf="variable.show_body == true" class="tr-{{index % 2}} child-tr">
          <td colspan="13"  class=" child-td">
            <table class="mb-0">
            <ng-container *ngFor="let item of orderData(variable['pf_prt_issue_childs']); let i = index">
              <ng-content *ngTemplateOutlet="tmplRef;
              context: { variable: item, index: i, level: level+1, agencyParent: variable?.tb_org_orgao.num_codigo_pk} ">
              </ng-content>
            </ng-container>
          </table>
          </td>
        </tr>
      </ng-container>
</ng-template >
<app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
<app-loading [loader]="isLoading"></app-loading>
<app-clonar-modal #clonarModal></app-clonar-modal>
<app-modal-responsavel #modalResonsavel></app-modal-responsavel>